import { useTranslation } from '@thoughtspot/i18n';
import { LoadingIndicator } from '@thoughtspot/radiant-react/widgets/loading-indicator';
import { Modal, ModalSize } from '@thoughtspot/radiant-react/widgets/modal';
import React from 'react';
import { useGetSourceDetailQuery } from '/@services/data-sources/data-sources-service';
import { UnderlyingDataSourcesContainerProps } from '../invite-users-v2.interface';
import { UnderlyingDataSources } from './underlying-data-sources';
import styles from './underlying-data-sources.module.scss';

export const UnderlyingDataSourcesContainer: React.FC<UnderlyingDataSourcesContainerProps> = ({
    pinboardName,
    dataSourceIDs,
    isDataSourceModalOpen,
    onConfirm,
}) => {
    const { t } = useTranslation();

    const {
        loading: isSourceDetailsLoading,
        data: sourceDetails,
    } = useGetSourceDetailQuery(dataSourceIDs);

    return (
        <Modal
            isOpen={isDataSourceModalOpen}
            size={ModalSize.MEDIUM3}
            title={t('invite.dataSource.underlyingDataSource')}
            confirmButton={{
                text: t('Back'),
                onConfirm,
            }}
        >
            <LoadingIndicator.Global
                hideLoader={!isSourceDetailsLoading}
                className={styles.loading_indicator}
            >
                <UnderlyingDataSources
                    pinboardName={pinboardName}
                    data={sourceDetails}
                />
            </LoadingIndicator.Global>
        </Modal>
    );
};
